import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ProjectFoldersGet } from '../project-folders.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { MatDialog } from '@angular/material/dialog';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { ModalService } from '@app/core/services/modal.service';
import { GridOptions, GridRow } from '@app/core/components/grid/grid.types';
import { Grid } from '@app/core/components/grid/grid.model';
import { StateService } from '@app/core/services/state.service';
import { UtilityService } from '@app/core/services/utility.service';

@Component({
    selector: 'tt-project-folder',
    templateUrl: './project-folder.component.html',
    styleUrls: ['./project-folder.component.css'],
})
export class ProjectFolderComponent implements OnChanges {
    @Input()
    public params?: ProjectFoldersGet;

    public get?: ProjectFolderGet;

    public searchtext = '';

    public selectedProject?: any;

    documentsGrid?: GridOptions;

    powtimesGrid?: GridOptions;

    checklistsGrid?: GridOptions;

    custactsGrid?: GridOptions;

    projectProcessesGrid?: GridOptions;

    @Output()
    folderChange = new EventEmitter<void>();

    @Output()
    onDelete = new EventEmitter<void>();

    searchProjectTemplates = () => {
        return this.datatask.Post(3836, this.get);
    };

    public copying = false;

    public deleting = false;

    constructor(
        private datatask: DataTaskService,
        private state: StateService,
        private modal: ModalService,
        private utility: UtilityService,
    ) {}

    private readProjectProcessesGrid() {
        if (!this.projectProcessesGrid) {
            this.createProjectProcessesGrid();
        } else {
            this.projectProcessesGrid.gridfunc?.read();
        }
    }

    private createProjectProcessesGrid() {
        this.projectProcessesGrid = new Grid()
            .setRememberId('w_projectfolders.projectprocesses_grid')
            .setLoadDataFunction({ method: 3842, parameters: () => ({ project_keyno: this.get?.project_keyno }) })
            .setCustomToolbarButtons([{ name: 'projectprosess_delete_selected', text: 'projectprosess_delete_selected', translate: true, icon: 'fas fa-trash', cssClass: 'tt-button tt-button--danger im-grid-btn-xs-l', func: () => this.deleteSelectedProcesses() }]);
    }

    private async deleteSelectedProcesses() {
        const selectedRows = this.projectProcessesGrid?.gridfunc?.getIsSelectedRows() ?? [];

        if (selectedRows.length === 0) return;

        let value = 0;
        const progressModal = this.modal.openProgressDialog({ value: value, max: selectedRows.length, rememberId: 'w_projectfolders.projectprocesses_grid.delete_progress_dialog' });

        for (const row of selectedRows) {
            try {
                const { errorcode, errormessage } = await this._deleteProjectProsess({ projectprosess_keyno: row['projectprosess_keyno'] });

                if ('' + errorcode !== '0') {
                    progressModal.updateStatus('invalid');
                    progressModal.updateInvalidText(errormessage);
                    break;
                } else {
                    value = value + 1;
                    progressModal.updateValue(value);
                }
            } catch (error) {
                console.error();
            }
        }

        if (value === selectedRows.length) {
            progressModal.updateStatus('finish');
        }

        this.readProjectProcessesGrid();
        this.folderChange.emit();
    }

    private readCustactsGrid() {
        if (!this.custactsGrid) {
            this.createCustactsGrid();
        } else {
            this.custactsGrid.gridfunc?.read();
        }
    }

    private createCustactsGrid() {
        this.custactsGrid = new Grid().setRememberId('w_projectfolders.custacts_grid').setLoadDataFunction({ method: 2452, parameters: () => ({ searchtext: '', ok: '0', filterfield: this.get?.item_type_selected, filtervalue: this.get?.item_id_selected.replaceAll('P', ''), custacttype: 'A', acttype: 'all', activitytype_no: '0', actstatus_keyno: '0', bg_main: 'SEARCH', bg_search: 'RESULT', member_portal_user_keyno: '0', reg_of_portal_user_keyno: '0', cust_no: '0' }) });
    }

    public powtimesGridReady = false;

    private readPowtimesGrid() {
        if (!this.powtimesGrid) {
            this.createPowtimesGrid();
        } else {
            this.powtimesGrid.gridfunc?.read();
        }
    }

    private createPowtimesGrid() {
        this.powtimesGridReady = true;
        // this.powtimesGrid = new Grid().setRememberId('w_projectfolders.powtimes_grid').setLoadDataFunction({
        //     method: 2127,
        //     parameters: () => ({
        //         webpage_name: 'projectmenu',
        //         businessco_no: '99999',
        //         show_setting: '1',
        //         argtype: this.get?.item_type_selected,
        //         argvalue: this.get?.item_id_selected,
        //         date_fom: '1901-01-01',
        //         date_tom: '2999-12-31',
        //         dateselector_index: '8',
        //         view_id: 'w_powtimes.grid',
        //         date_fomtom: '1901-01-012999-12-31',
        //         labour_no: '0',
        //         cust_no: '0',
        //         cust_name: '',
        //         project_keyno: '0',
        //         project_name: '',
        //     }),
        // });
    }

    private readChecklistsGrid() {
        if (!this.checklistsGrid) {
            this.createChecklistsGrid();
        } else {
            this.checklistsGrid.gridfunc?.read();
        }
    }

    private createChecklistsGrid() {
        this.checklistsGrid = new Grid()
            .setRememberId('w_checklists.grid')
            .setLoadDataFunction({
                method: 3841,
                parameters: () => ({
                    argtype: this.get?.item_type_selected,
                    argvalue: this.get?.item_id_selected.replaceAll('P', ''),
                }),
            })
            .setCustomToolbarButtons([
                {
                    name: 'gotoselect',
                    text: 'add_checklist',
                    translate: true,
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-l',
                    func: (event: any) => {
                        if (this.utility.isModifierKeyPressed(event)) {
                            this.state.newTab('selectchecklistadd', {
                                argtype: this.get?.item_type_selected,
                                argvalue: this.get?.item_id_selected.replaceAll('P', ''),
                            });
                        } else {
                            this.state.go('selectchecklistadd', {
                                argtype: this.get?.item_type_selected,
                                argvalue: this.get?.item_id_selected.replaceAll('P', ''),
                            });
                        }
                    },
                },
            ])
            .setSpecialFunc({
                buttons: [
                    {
                        name: 'open_checklist',
                        tooltip: 'open_checklist',
                        translateTooltip: true,
                        icon: 'fas fa-clipboard-list-check',
                        btn_type: 'primary',
                        func: (row: GridRow) => {
                            console.log(row);
                            this.modal.openStateDialog({ state: 'checklistdata', params: '' + row['checklistdata_keyno'] });
                        },
                    },
                ],
            });
    }

    public async openEditProjectProcess() {
        if (!this.get) return;

        const projectprocessKeyno = this.get.item_type_selected === 'projectprosess_keyno' ? this.get.item_id_selected.replaceAll('P', '') : '0';
        const submitted = await this.modal.openStateDialog({ state: 'projectprocess', params: `${this.get.project_keyno}/${projectprocessKeyno}/${this.get.projectprosess_keyno_belongto}` });

        if (!!submitted) {
            if (submitted === 'delete') {
                delete this.get;
                this.onDelete.emit();
            } else {
                this.folderChange.emit();
                this.loadGet();
            }
        }
    }
    public async openNewProjectProcess() {
        if (!this.get) return;

        const projectprocessBelongto = this.get.item_type_selected === 'projectprosess_keyno' ? this.get.item_id_selected.replaceAll('P', '') : '0';
        const submitted = await this.modal.openStateDialog({ state: 'projectprocess', params: `${this.get.project_keyno}/0/${projectprocessBelongto}` });

        if (!!submitted) {
            this.folderChange.emit();
            this.readProjectProcessesGrid();
        }
    }

    onProjectSelected(event?: any) {
        if (!this.get) return;

        this.get.copy_from_project_keyno = !!event ? '' + event.project_keyno : '0';
        this.get.copy_from_project_name = !!event ? event.project_name : '';
    }

    public async copy() {
        if (!this.get) return;

        try {
            this.copying = true;
            const { errorcode, errormessage } = await this.copyFoldersFromProjectTemplate(this.get);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.folderChange.emit();
                this.loadGet();
                //
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.copying = false;
        }
    }

    public async deleteProjectProsess() {
        if (!this.get) return;

        try {
            this.deleting = true;
            const { errorcode, errormessage } = await this._deleteProjectProsess({ projectprosess_keyno: this.get.item_id_selected.replaceAll('P', '') });

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                delete this.get;
                this.onDelete.emit();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.deleting = false;
        }
    }

    private async copyFoldersFromProjectTemplate(params: ProjectFolderGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3837, params))[0];
    }

    private async _deleteProjectProsess(params: ProjectProsessParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(1016, params))[0];
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.getProjectFolder(this.params);
            this.onTabSelected();
        }
    }

    private async getProjectFolder(params: ProjectFoldersGet) {
        return (await this.datatask.Post(3835, params))[0];
    }

    private async init() {
        await this.loadGet();
        // this.documentsGrid?.gridfunc?.read();
        // this.readPowtimesGrid();
        // this.readChecklistsGrid();
        // this.readCustactsGrid();
        // this.readProjectProcessesGrid();
    }

    onTabSelected() {
        if (!this.get) return;

        if (this.get.tab_projectfolders === 'DOCUMENTS') {
            this.documentsGrid?.gridfunc?.read();
        } else if (this.get.tab_projectfolders === 'POWTIMES') {
            this.readPowtimesGrid();
        } else if (this.get.tab_projectfolders === 'CHECKLISTS') {
            this.readChecklistsGrid();
        } else if (this.get.tab_projectfolders === 'CUSTACTS') {
            this.readCustactsGrid();
        } else if (this.get.tab_projectfolders === 'PROJECTPROSESSES') {
            this.readProjectProcessesGrid();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.init();
            //
        }
    }
}

export interface ProjectFolderGet extends Omit<ProjectFoldersGet, 'webpage_heading'> {
    show_button_copy_from_template: '1' | '0';
    folder_heading: string;
    projectprosess_keyno_belongto: `${number}`;
    projectprosess_keyno: `${number}`;
    copy_from_project_keyno: string;
    copy_from_project_name: string;
    show_button_delete_projectprosess: '1' | '0';
    show_button_create_new_projectprosess: '1' | '0';
    show_button_edit_projectprosess: '1' | '0';
    tab_projectfolders: string;
    show_tab_documents: '1' | '0';
    show_tab_powtimes: '1' | '0';
    show_tab_checklists: '1' | '0';
    show_tab_custacts: '1' | '0';
    show_tab_projectprosesses: '1' | '0';
}

export interface ProjectProsessParams {
    projectprosess_keyno: string | number;
}
